import { render, staticRenderFns } from "./createShop.vue?vue&type=template&id=18e1ad0b&scoped=true"
import script from "./createShop.vue?vue&type=script&lang=js"
export * from "./createShop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e1ad0b",
  null
  
)

export default component.exports